import React from 'react'

const TransferReceivedIcon = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_8276_13688)'>
      <path
        d='M16 31.0303C24.301 31.0303 31.0303 24.301 31.0303 16C31.0303 7.69902 24.301 0.969727 16 0.969727C7.69902 0.969727 0.969727 7.69902 0.969727 16C0.969727 24.301 7.69902 31.0303 16 31.0303Z'
        stroke='#2A1846'
      />
      <path
        d='M17.1092 14.1312C17.6425 14.6645 17.6425 15.5288 17.1092 16.0621C16.576 16.5953 15.7116 16.5953 15.1783 16.0621C14.645 15.5288 14.645 14.6645 15.1783 14.1312C15.7116 13.5979 16.576 13.5979 17.1092 14.1312Z'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.3896 13.7312V16.4624'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.8994 13.7312V16.4624'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.1445 19.876V23.2899'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.1445 23.29L17.51 21.9244'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.7783 21.9244L16.1439 23.29'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.4139 19.1934H11.3655C10.6111 19.1934 10 18.5823 10 17.8278V12.3655C10 11.6111 10.6111 11 11.3655 11H20.9245C21.6789 11 22.29 11.6111 22.29 12.3655V17.8278C22.29 18.5823 21.6789 19.1934 20.9245 19.1934H18.8761'
        stroke='#2A1846'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_8276_13688'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default TransferReceivedIcon
